import { DataService, Message } from "@/service";
import {UtilService,WinForm, ApiService} from '@/libs';

// 文件上传参数
interface UploadInter {
    files: Array<any>; // 文件数组
    limit: number; // 同时上传的数量
    oneDoneFn: Function; // 一个文件上传完成后执行的函数
    getUploadAdressFn: Function;
}

// 文件上传
export class ImgUploadObs {
    static queue: Array<any> = [];
    static stack: Array<any> = [];
    static oneDoneFn: Function;
    static getUploadAdressFn: Function;
    // 上传文件
    static uploadFiles({ files, limit, oneDoneFn ,getUploadAdressFn}: UploadInter) {
        this.queue = [];
        this.stack = [];
        this.oneDoneFn = oneDoneFn;
        this.getUploadAdressFn = getUploadAdressFn;
        limit = limit || 5;

        this.queue.push(...files);
        let len = files.length > limit ? limit : files.length;
        let pushList = this.queue.splice(0, len);
        this.stack.push(...pushList);
        this.stack.forEach((item) => {
            this.upFile(item);
        });
        return new Promise((resolve, reject) => {
            let timer: any = setInterval(() => {
                if (this.queue.length == 0 && this.stack.length == 0) {
                    resolve(files);
                    clearInterval(timer);
                }
            }, 100);
        });
    }

    static getFileHash(path: string) {
        return new Promise((resolve) => {
            // 大文件上传会长时间卡顿
            setTimeout(() => {
                let hash = WinForm.md.getFileHash(path); // 同步获取fileHash
                resolve(hash);
            }, 50);
        });
    }

    private static oneDone(doneFile: any) {
        if (this.oneDoneFn) this.oneDoneFn(doneFile);

        let index = this.stack.findIndex((item) => item.Path === doneFile.Path);
        this.stack.splice(index, 1); // 删掉已完成
        if (this.queue.length !== 0) {
            let nextFile = this.queue.splice(0, 1)[0]; // 截取file
            this.stack.push(nextFile); // 推入stack
            this.upFile(nextFile);
        }
    }

    private static async upFile(file: any) {
        try {
            file.UploadKey = UtilService.Guid();
            // 判断是否上传
            if (file.FileServerPath) {
                this.upFileProgress(file.UploadKey, 100, "", "MD_COMPLETE", "");
            } else {
                this.upFileProgress(file.UploadKey, 0, "", "MD_UPLOAD", ""); // 初始
                if (file.ScreenShoot) {
                    file.FileHash = WinForm.md.getMD5Hash(file.Path);
                } else {
                    file.OldFileHash = file.FileHash; // 缓存本地的hash
                    file.FileHash = await this.getFileHash(file.Path);
                }
                let params = {
                    FilePath: file.Path,
                    FileHash: file.FileHash,
                    FileExt: file.FileExt,
                    uploadKey: file.UploadKey,
                };
                //let res = await FileUpload.existFile("product", params, this.upFileProgress)
                let res = await this._ossSignature("product", params, this.upFileProgress);
                file.FileServerPath = res.FileServerPath;
                file.FileBucket = res.FileBucket;
                //if (!res.hasOwnProperty("uploadId")) {
                // 如果没有返回ID 说明已经上传过了；  // 没有上传过，走oss
                this.upFileProgress(file.UploadKey, 100, "", "MD_COMPLETE", "");
                //}
            }
        } catch (error) {
            ImgUploadObs.upErrorHandle(file, error.Message);
        }
    }

    private static upErrorHandle(file: any, errMsg: string) {
        file.IsError = true;
        file.ErrorMsg = errMsg;
        ImgUploadObs.oneDone(file);
    }

    private static upFileProgress(key: any, progress: any, speed: any, status: any, statusDesc: any, totalSize?: any) {
        // console.log("file：", key, progress, speed, status, statusDesc, totalSize);
        let file = ImgUploadObs.stack.find((file) => file.UploadKey === key);
        // 上传出错；
        if (status === "MD_ERROR") {
            Message.error(statusDesc);
            clearInterval(file.timer);
            ImgUploadObs.upErrorHandle(file, statusDesc);
        } else {
            if (file && file.hasOwnProperty("Percent")) {
                // 平滑进度a
                if (file.timer) clearInterval(file.timer);
                file.timer = setInterval(() => {
                    if (progress > file.Percent) {
                        file.Percent += 1;
                    } else {
                        clearInterval(file.timer);
                        file.timer = null;
                        if (file.Percent >= 100 && status == "MD_COMPLETE") {
                            if (!file.FileSize && totalSize) file.FileSize = totalSize;
                            else ImgUploadObs.oneDone(file);
                        }
                    }
                }, 10);
            } else {
                // if (progress == 100 && status == "MD_COMPLETE") {
                // 	if (!file.FileSize && totalSize) file.FileSize = totalSize;
                // 	ImgUploadObs.oneDone(file);
                // }
            }
        }
    }

    // static async existFile(category: any, file: any, progress: Function, priv: boolean = false) {
    // 	try {
    // 		return await DataService.get(`${ApiService.Host}/file/exists?hash=${file.FileHash}`);
    // 	} catch (e) {
    // 		return await this._ossSignature(category, file, progress, priv);
    // 	}
    // }

    static async _ossSignature(category: any, _file: any, progress: Function, priv: boolean = false) {
        //获取oss上传签名
        let type = ImgUploadObs.getFileType(_file.FileExt.toLowerCase());

        let res = await DataService.post(`${ApiService.EngineerApi}/obs/createSignedUrl`, {
            category:category,
            key:_file.FileHash,
            priv:priv,
            ContentType: type,
        });
        console.log(_file, 'res--666')
        // this.getUploadAdressFn(res.data)
        // let uploadId = WinForm.md.upload(_file.FilePath, res.data, type, progress, _file.uploadKey);
        // console.log(res, 'res--')
        const result = await ImgUploadObs.imgLoad(_file, res.data.signature.url)
        let file: any = {
            FileServerPath: res.datasignature.key,
            FileBucket: res.data.signature.bucket,
            // uploadId,
        };
        return file;
    }

    static  getFileType(FileExt: string) {
        switch (FileExt) {
            case ".doc":
            case ".rtf":
                return "application/msword";
            case ".pdf":
                return "application/pdf";
            case ".docx":
                return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            case ".xls":
                return "application/vnd.ms-excel";
            case ".xlsx":
                return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            case ".ppt":
                return "application/vnd.ms-powerpoint";
            case ".pptx":
                return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        }
    }

    static async imgLoad(file:any, uploadUrl:string) {
         const imageTypes:any = {
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'bmp': 'image/bmp',
            'webp': 'image/webp'
        };
        const extension = file.FileExt.split('.').pop().toLowerCase();
        const contentType  = imageTypes[extension] || 'application/octet-stream';
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            
            // 监听上传进度
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    console.log(`上传进度: ${percentComplete.toFixed(2)}%`);
                    // 这里可以更新UI显示进度
                }
            });
            
            // 监听完成事件
            xhr.addEventListener('load', () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText);
                } else {
                    reject(new Error(`上传失败: ${xhr.statusText}`));
                }
            });
            
            // 监听错误事件
            xhr.addEventListener('error', () => {
                reject(new Error('网络错误，上传失败'));
            });
            
            // 初始化请求
            xhr.open('PUT', uploadUrl, true);
            
            // 设置必要的头部（根据OBS要求）
            xhr.setRequestHeader('Content-Type', contentType);
            
            // 发送文件数据
            xhr.send(file);
        });
    }

}
